import React, { useEffect, useState } from 'react';
import { Card, Button, Container, Row, Col } from 'react-bootstrap';
import {
    MDBContainer
} from 'mdb-react-ui-kit';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fetchPostData } from './api'; // Import your common API file

const Dashboard = () => {
    // Static messages for the cards
    const staticMessages = [
        { title: 'Total candidates', value: '50K' },
        { title: 'Total company', value: '12K' },
        { title: 'Total payments', value: '1.5 L' },
        { title: 'Total male candidates', value: '250K' },
        { title: 'Total female candidates', value: '350K' },
        { title: 'Payment failure candidates', value: '15 L' }
    ];
    const [messages, setMessages] = useState(staticMessages); // Set static messages
    const [data, setData] = useState({ totalCompanies: 0, totalPaid: 0 });

    ChartJS.register(
        BarElement,
        CategoryScale,
        LinearScale,
        Tooltip,
        Legend,
        ChartDataLabels
    );

    const chartData = {
        labels: ['Jobs Pro'],
        datasets: [
            {
                label: 'Payments',
                data: [data.totalPaid],
                backgroundColor: ['#3b71ca', '#9e9e9e'],
                borderRadius: 5
            }
        ]
    }
    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: true
            },
            datalabels: {
                anchor: 'end',
                align: 'end',
                offset: -6,
                color: '#000',
                font: {
                    weight: 'bold',
                    size: 14
                },
                formatter: (value) => value
            }
        },
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };

    // Handle button click
    const handleClick = (index) => {
        const updatedMessages = [...messages];
        updatedMessages[index].value = 'Hello, React!'; // Show custom text for clicked card
        setMessages(updatedMessages);
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        const user_id = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : 0;

        if (user_id) {
            const fetchData = async () => {
                try {
                    const requestData = {
                        user_id,
                    }
                    const response = await fetchPostData('/billing/executive/teamSummary', JSON.stringify(requestData), {
                        'Content-Type': 'application/json',
                    });
                    if (response.success) {
                        setData(response.data); // assuming your API returns { status: true, data: { totalCompanies, totalPaid } }
                    }
                } catch (error) {
                    console.error('Summary fetch failed', error);
                }
            };

            fetchData(); // invoke the async function
        }
    }, []);

    return (
        <Container className="mt-5" >
            <Row className="mb-5">
                <Col xs={12} md={{ span: 6, offset: 3 }}>
                    <MDBContainer className="mt-5 text-center" style={{ maxWidth: '600px' }}>
                        <h4>Team-wise Payment Status</h4>
                        {/* ✅ Use chartData and chartOptions here */}
                        <Bar data={chartData} options={chartOptions} />
                    </MDBContainer>
                </Col>
            </Row>

            <Row>
                {messages.map((message, index) => (
                    <Col key={index} xs={12} sm={6} md={4} className="mb-4"> {/* 4 columns per row (3 cards) */}
                        <Card className="text-center">
                            <Card.Header>Card {index + 1}</Card.Header>
                            <Card.Body>
                                <Card.Title>{message.title}</Card.Title>
                                <Card.Text>{message.value}</Card.Text>
                                <Button variant="primary" onClick={() => handleClick(index)}>Click Me!</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container >
    );
};

export default Dashboard;
